<button nz-button nzType="primary" class="default-button" (click)="onEdit(data)">Query</button>